import { CalculatorPage } from './components/CalculatorPage';
import { CapitalPage } from './components/CapitalPage';
import { CarPage } from './components/CarPage';
import { DashboardPage } from './components/DashboardPage';
import { Nav } from './components/Nav';
import { PipelinePage } from './components/PipelinePage';
import { RulesPage } from './components/RulesPage';
import { SettingsPage } from './components/SettingsPage';
import { useHashRoute } from './state/useHashRoute';

export function App() {
  const route = useHashRoute();
  const [page = 'calculator', arg] = route;
  const current = page === 'car' ? 'pipeline' : page;

  let view;
  switch (page) {
    case 'pipeline': view = <PipelinePage />; break;
    case 'car': view = arg ? <CarPage id={arg} /> : <PipelinePage />; break;
    case 'dashboard': view = <DashboardPage />; break;
    case 'capital': view = <CapitalPage />; break;
    case 'rules': view = <RulesPage />; break;
    case 'settings': view = <SettingsPage />; break;
    default: view = <CalculatorPage />;
  }
  return (
    <>
      <a className="skip" href="#main">Skip to content</a>
      <Nav current={current} />
      <main id="main">{view}</main>
      <footer className="foot">Estimates only, not financial, tax or legal advice. Your data stays in this browser.</footer>
    </>
  );
}
